<template>
    <div id="app">
        <div class="content">
            <nuxt />
        </div>
    </div>
</template>
<script>
export default {
    name: "AppEmpty",
};
</script>
